export function b64EncodeUnicode(input: string) {
  return btoa(encodeURIComponent(input));
}

export function unicodeDecodeB64(input: string) {
  return decodeURIComponent(atob(input));
}
